import { DeprecatedModal } from '@aon-coverwallet/cw-react-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notificationModalsActions } from 'src/redux/actions';
import { ModalContentContainer, ModalTitle } from '../pages/accounts/styles';
import { StyledPrimaryButton } from 'src/components/common/styledComponents/styledButton';
import TrackingHelper from 'src/utils/trackingHelper';

const NotificationModalView = ({
  isOpen,
  modalType,
  title,
  subTitle,
  confirmButtonName,
  notificationModals,
}) => {
  const onClose = closureReason => {
    notificationModals.closeNotificationModal(modalType);
    TrackingHelper.track('Modal Closed', {
      modalName: `${modalType}_notification_modal`,
      closureReason,
    });
  };

  const { t } = window.translation;

  return (
    <DeprecatedModal
      modalContainerStyles={{ position: 'fixed' }}
      isOpen={isOpen}
      onClose={() => onClose('[X]')}
      modalRootId="modal-root"
    >
      <ModalContentContainer>
        <ModalTitle centered large>
          {t(title)}
        </ModalTitle>
        {subTitle && (
          <ModalTitle centered small>
            {t(subTitle)}
          </ModalTitle>
        )}
        <div className="edit-warning-modal__actions">
          <StyledPrimaryButton onClick={() => onClose('Accept')} secondaryColor>
            {t(confirmButtonName)}
          </StyledPrimaryButton>
        </div>
      </ModalContentContainer>
    </DeprecatedModal>
  );
};

NotificationModalView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  confirmButtonName: PropTypes.string,
  notificationModals: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    notificationModals: bindActionCreators(notificationModalsActions, dispatch),
  };
};

const NotificationModal = connect(
  null,
  mapDispatchToProps,
)(NotificationModalView);

export { NotificationModal };
